import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import menu from './modules/menu' // 引入模块
import tagsView from './modules/tagsViews'
import bigscreenTab from './modules/bigscreenTab' // 大屏tab切换状态
// 加载 状态模块
export default new Vuex.Store({

	state: {
		showAlert:false,
		data:{}
	},
	mutations: {
		removeAlertFn(state,payload) {
			state.showAlert = false
		},
		showAlertFn(state,data) {
			state.showAlert = true
			state.data = data
		}
	},


	modules: {
		menu,
		tagsView,
		bigscreenTab,
	}
})
